export const showEmailAccountStatusError = (oem) =>
  oem?.emailAccountStatus && oem?.emailAccountStatus !== "connected";

export const getEmailAttachmentsUploadObject = (
  user,
  files,
  forceCustomPath = true,
  forceUniqueFilename = false,
) => ({
  folder: `downloads/oem/${user.oem.slug}/email`,
  files,
  forceCustomPath,
  forceUniqueFilename,
});

/**
 * Returns a unique filename by appending (1), (2), etc. if the name already exists
 * @param {string} name - The original filename
 * @param {string[]} existingNames - Array of existing filenames to check against
 * @returns {string} - A unique filename
 */
export const getUniqueFilename = (name, existingNames) => {
  if (!existingNames.includes(name)) {
    return name;
  }

  const lastDotIndex = name.lastIndexOf(".");
  const hasExtension = lastDotIndex > 0;
  const baseName = hasExtension ? name.slice(0, lastDotIndex) : name;
  const extension = hasExtension ? name.slice(lastDotIndex) : "";

  let counter = 1;
  let newName = `${baseName} (${counter})${extension}`;

  while (existingNames.includes(newName)) {
    counter++;
    newName = `${baseName} (${counter})${extension}`;
  }

  return newName;
};
